export enum DemandeAchatStatus {
  EN_COURS_TRAITEMENT = 'en_cours_traitement',
  VALIDE = 'valide',
  REFUSE = 'refuse',
  BLOQUE = 'bloque',
  EN_COURS_LIVRAISON = 'en_cours_livraison',
  RECEPTIONNE = 'receptionne',
}

export const DEMANDE_ACHAT_STATUS_LABELS: Record<string, string> = {
  en_cours_traitement: 'En cours de traitement',
  valide: 'Validé',
  refuse: 'Refusé',
  bloque: 'Bloqué',
  en_cours_livraison: 'En cours de livraison',
  receptionne: 'Réceptionné',
};

export interface DemandeAchatItem {
  id: number;
  demande_achat_id: number;
  article_id?: number | null;
  designation: string;
  quantite: number;
  commentaire?: string | null;
  created_at?: string;
  // Enriched
  article_reference?: string | null;
  unit?: string | null;
}

export interface DemandeAchatItemCreate {
  article_id?: number | null;
  designation: string;
  quantite: number;
  commentaire?: string | null;
}

export interface DemandeAchat {
  id: number;
  reference: string;
  date: string;
  user_id: number;
  projet_id: number;
  projet_code?: string | null;
  projet_nom?: string | null;
  status: DemandeAchatStatus | string;
  commentaire_manager?: string | null;

  // Per-status timestamps + user IDs
  valide_at?: string | null;
  valide_by?: number | null;
  refuse_at?: string | null;
  refuse_by?: number | null;
  bloque_at?: string | null;
  bloque_by?: number | null;
  livraison_at?: string | null;
  livraison_by?: number | null;
  receptionne_at?: string | null;
  receptionne_by?: number | null;

  created_at?: string;
  updated_at?: string;
  deleted_at?: string;

  // Enriched
  user_name?: string | null;
  valide_user_name?: string | null;
  refuse_user_name?: string | null;
  bloque_user_name?: string | null;
  livraison_user_name?: string | null;
  receptionne_user_name?: string | null;

  // Items
  items: DemandeAchatItem[];
  total_items: number;
}

export interface DemandeAchatCreate {
  date: string;
  projet_id: number;
  items: DemandeAchatItemCreate[];
}

export interface DemandeAchatUpdate {
  date: string;
  projet_id: number;
  status?: DemandeAchatStatus | string;
  commentaire_manager?: string | null;
  items?: DemandeAchatItemCreate[];
}

export interface DemandeAchatStatusUpdate {
  status: DemandeAchatStatus | string;
  commentaire_manager?: string | null;
}

export interface DemandeAchatListResponse {
  total: number;
  items: DemandeAchat[];
}
